import React from 'react'
import { Link } from 'react-router-dom'
const TrainingWorkshop = () => {
  return (
    <>
    <section className="page-header">
        <div className="page-header-bg"></div>
        <div className="page-header-shape-1"><img src="/Images/page-header-shape-1.png" alt="Loreto Convent School, Delhi Cantt"/></div>
        <div className="container">
        <div className="page-header__inner">
            <ul className="thm-breadcrumb list-unstyled ml-0">
                <li><Link to="/"> Home</Link></li>
                <li> Training & Workshop   </li>
            </ul>
            <h2>Training & Workshop  </h2>
        </div>
        </div>
    </section>
    <section className="innerbody">
   <div className="container">
      <div className="row">
         <div className="col-md-12">
            <div className="accordion achievementacc" id="accordionExample">
               <div class="accordion-item">
               <div className="card">
                  <div className="card-header">
                     <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="true" aria-controls="collapseEight">
                      National Progressive School Conference
                     </button>
                  </div>
                  <div id="collapseEight" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                     <div className="card-body">
                        <div className="workk">
                            <p> The NPSC (National Progressive School Conference) had organised a workshop on ‘Beyond Teaching’ on 27 April 2024 at Ahlcon International School, Mayur Vihar. The workshop primarily focussed on the topic ‘Living in Excellence’ for the teachers of the NPSC member schools in collaboration with Chinmaya Mission, Noida. The workshop was attended by Mrs. Suman Sharma.
                           </p>
                         
                           <br/>
                           <center>
                              <img src="/Images/npsc.jpg" className="img-fluid mx-auto d-block imgspace" alt="Loreto Convent School, Delhi Cantt"/>   
                           </center>
                        </div>
                     </div>
                  </div>
               </div>
 </div>
             <div class="accordion-item">
               <div className="card">
                  <div className="card-header">
                     <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="true" aria-controls="collapseEight">
                     READING MISSION
                     </button>
                  </div>
                  <div id="collapseEight" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                     <div className="card-body">
                        <div className="workk">
                           <p>  The CBSE had organised a workshop on the Science of Reading on 05 April 2024 at Bal Bhawan Public School, Mayur Vihar,Delhi. The workshop primarily focussed on the Reading Mission undertaken by the CBSE to attempt Guinness World Record for ‘the most children reading at one time’ on National Reading Day. The workshop was attended by the school Principal, Mrs. Alice Rose D’Lima and the Head of the Department of English, Mrs. Rekha Jacob.
                           </p>
                         
                           <br/>
                           <center>
                              <img src="/Images/readingmission.jpg" className="img-fluid mx-auto d-block imgspace" alt="Loreto Convent School, Delhi Cantt"/>   
                           </center>
                        </div>
                     </div>
                  </div>
               </div>

               </div>
                <div class="accordion-item">
                  <div className="card">
                  <div className="card-header">
                     <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                     CAPACITY BUILDING PROGRAM XII PHYSICS
                     </button>
                  </div>
                  <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                     <div className="card-body">
                        <div className="workk">
                           <p>A Capacity building workshop was organized on 19 and 20 September 2019 for XII PHYSICS
                              It was very subject enriching and interesting program.
                           </p>
                           <p>The resource persons were</p>
                           <p>1. Dr. Rajeev Tyagi Principal Mount Carmel school dwarka</p>
                           <p>2. Pragya Nopani well known physics teacher at Anveshika</p>
                           <p>I (Mr. Ajay Kumar) will say thank you to my Principal Sr Monica for giving me this opportunity.</p>
                           <br/>
                           <center>
                              <img src="/Images/PROGRAMXIIPHYSICS.jpg" className="img-fluid mx-auto d-block imgspace" alt="Loreto Convent School, Delhi Cantt"/>    
                           </center>
                        </div>
                     </div>
                  </div>
               </div>
               </div>
                <div class="accordion-item">
                  <div className="card">
                  <div className="card-header">
                     <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                     Capacity building program for Science
                     </button>
                  </div>
                  <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                     <div className="card-body">
                        <div className="workk">
                           <p>A Capacity building workshop for Science of class X was organized on 20 and 21 September at Sant Nirankari school.Mrs Rupinder Oberoi from Loreto Convent School attended this two day workshop.The two resource speakers Mrs Veena Mishra -Principal National Victor School and Mr Shubham Chakarborty demonstrated such interesting activities for effective teaching of science in class X.
                              The workshop was so interesting and informative that it kept all the teachers totally involved for two days.
                              The new pattern of CBSE assessment and evaluation of class X was also discussed.It was truly an enriching  experience.
                           </p>
                           <br/>
                           <center>
                              <img src="/Images/capacity-building.jpg" className="img-fluid mx-auto d-block imgspace" alt="Loreto Convent School, Delhi Cantt"/>   
                           </center>
                        </div>
                     </div>
                  </div>
               </div>
               </div>
                <div class="accordion-item">
                  <div className="card">
                  <div className="card-header">
                     <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                     CBSE capacity building workshop psychology 
                     </button>
                  </div>
                  <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                     <div className="card-body">
                        <div className="workk">
                           <p>On 30th and 31st July,I Risa Joseph attended a workshop held by CBSE related to class 11 and 12 Psychology. the workshop was 
                              held at Sri venkatashwara school sector 18 Dwarka. The resource person for the workshop was Mrs Usha Anand, She is also one 
                              of the author's for the NCERT textbook  Psychology for classes 11 and 12.The main points discussed during the workshop was 
                              regarding practical work, assessment, changes in chapter 'Psychological disorder' and how to make topics more interesting.it 
                              was a learning experience for me.
                           </p>
                           <br />

<div className="row">
<div className="col-md-4"> <center>
                              <img src="/Images/psychology-1.jpg" className="img-fluid mx-auto d-block imgspace" alt="Loreto Convent School, Delhi Cantt"/>  
                           </center></div>
<div className="col-md-4"> <center>
                              <img src="/Images/psychology-2.jpg" className="img-fluid mx-auto d-block imgspace" alt="Loreto Convent School, Delhi Cantt"/>  
                           </center></div>
</div>

                        </div>
                     </div>
                  </div>
               </div>
               </div>
                <div class="accordion-item">
                  <div className="card">
                  <div className="card-header">
                     <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    ENGLISH CBP XII
                     </button>
                  </div>
                  <div id="collapseFour" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                     <div className="card-body">
                        <div className="workk">
                       <h1 className="head1">Capacity Building Programme</h1>
                       <p>A workshop was conducted by CBSE, Centre of Excellence on 19 and 20 July 2019 at Ambience Public School, Safdarjung Enclave. 
                        The resource persons were Mr. Derek Richard Brendish, Principal of Apex Public School and Mrs. Soumya Gulati, Deputy Director 
                        of Bluebells Group of Schools.</p>
                       <p>It was a Capacity Building Programme (CBP) for teachers teaching English in classes XI and XII, based on the revised syllabus of
                       English (core). The aim of the workshop was to familiarise the teachers with the additional chapters in the Literature section 
                       and the   inclusion of ASL as Practical Exam for Class XII. </p>
                       <p>The workshop provided a platform for professional development as well as helped in making English language learning more effective and 
                       conducive for the learners with the help of various strategies.</p>
                       <p>Ms.Bindu Jaggi and Ms.Rekha Jacob attended the workshop</p>
                       <br/>
                       <center>
                        <img src="/Images/Capacity-Building-2.jpg" className="img-fluid mx-auto d-block imgspace" alt="Loreto Convent School, Delhi Cantt"/>  
                        </center>
                      </div>
                     </div>
                  </div>
               </div>
               </div>
                <div class="accordion-item">
                  <div className="card">
                  <div className="card-header">
                     <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                    MATHS
                     </button>
                  </div>
                  <div id="collapseFive" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                     <div className="card-body">
                        <div className="workk">
                       <p>Ms. Leena Job Mathew and Ms. Purnima Bhatti attended a Mathematics Workshop on Teaching Mathematics through Lab Activities, conducted 
                           at MBS International Schoo ,Dwarka on 20 July 2019. The main speaker for the work shop was Dr. Hukum Singh from NCERT. He explained 
                           the necessity and importance of hands on experience in teaching Mathematics. It was an enriching experience.The teachers were awarded 
                           a Certificate for participation.</p> 
                           <br />
                         <div className="row">
   <div className="col-md-4">
      <center>
         <img src="/Images/math-1.jpg" className="img-fluid mx-auto d-block imgspace" alt="Loreto Convent School, Delhi Cantt"/>   
      </center>
   </div>
   <div className="col-md-4">
      <center>
         <img src="/Images/math-2.jpg" className="img-fluid mx-auto d-block imgspace" alt="Loreto Convent School, Delhi Cantt"/>   
      </center>
   </div>
</div>  
                           
                         </div>
                     </div>
                  </div>
               </div>
               </div>
                <div class="accordion-item">
                  <div className="card">
                  <div className="card-header">
                     <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                   The CBSE Capacity Building Programme for Hindi teachers
                     </button>
                  </div>
                  <div id="collapseSix" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                     <div className="card-body">
                        <div className="workk">
                       <p>The CBSE Capacity Building Programme for Hindi teachers was organised at St. Francis de Sales Senior Secondary School, Janakpuri, New Delhi. The two days Workshop Programme(23-24 July 2019) provided platform for teachers to upgrade their pedagogical skills and use latest technology tools to make learning process more realistic, stress free and joyful.</p> 
                           <br />
                         <div className="row">
   <div className="col-md-4">
      <center>
         <img src="/Images/CBSE-Capacity-1.jpg" className="img-fluid mx-auto d-block imgspace" alt="Loreto Convent School, Delhi Cantt"/>  
      </center>
   </div>
   <div className="col-md-4">
      <center>
         <img src="/Images/CBSE-Capacity-2.jpg" className="img-fluid mx-auto d-block imgspace" alt="Loreto Convent School, Delhi Cantt"/>  
      </center>
   </div>
   </div>  
                           
                         </div>
                     </div>
                  </div>
               </div>
               </div>
                <div class="accordion-item">
                  <div className="card">
                  <div className="card-header">
                     <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                  Khelo India
                     </button>
                  </div>
                  <div id="collapseSeven" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                     <div className="card-body">
                        <div className="workk">
                       <p>I Mrs. SNEHLATA AGGARWAL attended Khelo India school fitness assessment program conducted by cbse in association with Sports Authority of India on22nd june 2019 held at Red Roses Public School, Palam Vihar,s Gurugram. Khelo India is a National programme for development of sports in India,was introduced in December 2017 by the Ministry of Youth Affairs and sports, Government of India to revive sports culture in India at grass roots level. All the school are directed by CBSE to conduct fitness tests from classes 1 to 12.</p> 
                           <br />
                      <center>
                        <img src="/Images/KheloIndia.jpg" className="img-fluid mx-auto d-block imgspace" alt="Loreto Convent School, Delhi Cantt"/> 
                        </center>
                         </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   </div>
</section>
   </>
  )
}

export default TrainingWorkshop